module.exports = __webpack_public_path__ + "static/zap-1f3b468b69f9fe5098641e95f0a09046.png";